export const scrollToTopModule = {
  name: 'Scroll To Top',
};
